import { useActiveUserStore } from '@/stores/user';
import api from './api';
import { track } from './tracker';

// Helper to destroy a user session.
export function destroyUserSession() {
  const userStore = useActiveUserStore();

  return api
    .delete('/v2/sessions')
    .then(({ data }) => {
      track('signout', data.data);
      if (data.data?.sessionId) {
        const user = data.data;
        userStore.setActiveUser(user);
      } else {
        sessionStorage.clear();
        userStore.setActiveUserToPublic();
      }
    })
    .catch((error) => {
      if (error.response) console.error(error.response.data);
    });
}

export function createUserSession() {
  const userStore = useActiveUserStore();
  return api
    .get('/v2/sessions')
    .then((response) => {
      const user = response.data.data;
      userStore.setActiveUser(user);
    })
    .catch((e) => {
      if (e.response) {
        const statusCode = e.response.status;

        // reset store if it has an active user and server returns a 4xx error.
        if (userStore.activeUserId && statusCode >= 400 && statusCode <= 499) {
          userStore.reset();
        }
      }
    });
}
